import axios from '@/plugins/axios'

import { useAuthorizationStore } from '@/store/authorizationStore'

const getWorkspaceId = () => useAuthorizationStore().getWorkspaceSlug

const getDisputes = (params) => axios.get(`${getWorkspaceId()}/disputes`, { params })
const getDisputeFiltersAndSorting = () => axios.get(`${getWorkspaceId()}/disputes/filters-and-sortings`)
const getPendingCount = () => axios.get(`${getWorkspaceId()}/disputes/pending-count`)
const getCreateDataDispute = (slug) => axios.get(`${getWorkspaceId()}/disputes/${slug}`)
const resolveDisputes = (formData) => axios.patch(`${getWorkspaceId()}/disputes/resolve`, formData)
const getDetailDispute = ({ callSlug, disputeSlug }) => axios.get(`${getWorkspaceId()}/disputes/${callSlug}/${disputeSlug}`)
const creteDispute = ({ formData, slug }) => axios.post(
    `${getWorkspaceId()}/disputes/${slug}`,
    formData,
    {
        headers: { 'Content-Type': 'multipart/form-data' },
    },
)

export {
    getCreateDataDispute,
    creteDispute,
    getDisputes,
    getDisputeFiltersAndSorting,
    resolveDisputes,
    getDetailDispute,
    getPendingCount,
}
